import axios from "axios";
import i18n from "i18next";
import { config } from "./global";
//process.env variable to be added
//apiconfig/ apiconstants to be added

//ToDo:This can be uncommented once the CMS supports all country lang codes.
// Now only handling english and thai
const countryLanguageCodeContent = i18n.language?.split("-")[1] + "/" + i18n.language?.split("-")[0] || "th/en";
const countryLanguageCode = i18n.language || "en-th";
function getCountryLanguageCode() {
  if (countryLanguageCode && countryLanguageCode == "index" && !window.location.pathname.includes("/booking/")) {
    return window.location.pathname.split("/")[1];
  } else if (window.location.pathname.includes("/booking/")) {
    return i18n.language;
  } else {
    return window.location.pathname.split("/")[1];
  }
}
function getCountryLanguageCodeContent() {
  if (countryLanguageCodeContent && (countryLanguageCodeContent.includes("index") || countryLanguageCodeContent.includes("undefined"))) {
    var countryLanguageCode = i18n.language || window.location.pathname.split("/")[1];
    return countryLanguageCode.split("-")[1] + "/" + countryLanguageCode.split("-")[0];
  } else {
    return countryLanguageCodeContent;
  }
}
function getAemBaseUrl() {
  var rootdomain = window.location.origin;
  if (rootdomain.includes("localhost")) {
    return process.env.REACT_APP_AEM_ROOT_DOMAIN;
  } else {
    return rootdomain + "/";
  }
}
const base_urls = {
  teamsite: process.env.REACT_APP_TG_TEAMSITE_URL + "en-th",
  aemContentAuthored: getAemBaseUrl() + process.env.REACT_APP_TG_AEM_BASE_URL,
  aemConfigured: getAemBaseUrl(),
  aemServlet: getAemBaseUrl() + process.env.REACT_APP_TG_AEM_SERVLET_URL,
  dapiCheckinAEMContentAuthored: getAemBaseUrl() + config.REACT_APP_DAPI_TG_AEM_BASE_URL,
  dapiCheckinJson: getAemBaseUrl() + config.REACT_APP_DAPI_TG_AEM_JSON_BASE_URL,
  dapiBookingJson: getAemBaseUrl() + config.REACT_APP_DAPI_BOOKING_TG_AEM_JSON_BASE_URL,
  dapiMMBJson: getAemBaseUrl() + config.REACT_APP_DAPI_MMB_TG_AEM_JSON_BASE_URL,
  dapiBookingAem: getAemBaseUrl() + config.DAPI_BOOKING_CONTENT_AEM,
  osciJson: getAemBaseUrl() + config.REACT_APP_OSCI_TG_AEM_JSON_BASE_URL
};
const cmsApi = axios.create();
const isRopEnabled = sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;

// Request interceptor
cmsApi.interceptors.request.use(config => {
  // Modify the request config here (e.g., add headers, authentication tokens)
  config.baseURL = base_urls?.[config?.engine];
  if (config?.engine == "aemContentAuthored" || config?.engine == "dapiCheckinAEMContentAuthored") {
    config.baseURL += getCountryLanguageCodeContent();
  }
  if (isRopEnabled) {
    if (config?.headers?.["App-Authorization"]?.includes("Basic")) delete config.headers["App-Authorization"];
  } else {
    if (config?.headers?.Authorization?.includes("Basic")) delete config.headers.Authorization;
  }
  if (config?.engine == "aemServlet") config.url += "?" + getCountryLanguageCode();
  return config;
}, error => {
  // Handle request errors here

  return Promise.reject(error);
});

// Response interceptor
cmsApi.interceptors.response.use(response => {
  // Modify the response data here (e.g., parse, transform)

  return response;
}, error => {
  // Handle response errors here

  return Promise.reject(error);
});
export default cmsApi;